export default "__VITE_ASSET__22896926__"